<template>
  <b-card class="card-loading-service" v-if="isBusy">
    <b-avatar :icon="icon" size="5em"></b-avatar>
    <span class="my-3">{{ textBeforeCreated }}</span>
    <b-spinner type="grow" label="Spinning"></b-spinner>
  </b-card>
  <b-card class="card-loading-service" v-else-if="isError">
    <b-avatar :icon="icon" size="5em"></b-avatar>
    <span class="my-3">{{ textErrorCreated }}</span>
    <b-icon icon="x-circle-fill" variant="danger" font-scale="2em" />
  </b-card>
  <b-card class="card-loading-service" v-else>
    <b-avatar :icon="icon" size="5em"></b-avatar>
    <span class="my-3">{{ textAfterCreated }}</span>
    <b-icon icon="check-circle-fill" variant="success" font-scale="2em" />
  </b-card>
</template>

<script>
export default {
  name: "ServiceLoadingCard",
  props: {
    icon: {
      type: String,
      required: true
    },
    isBusy: {
      type: Boolean,
      required: true
    },
    isError: {
      type: Boolean,
      required: true
    },
    textBeforeCreated: {
      type: String,
      required: true
    },
    textAfterCreated: {
      type: String,
      required: true
    },
    textErrorCreated: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss">
.card-loading-service {
  @media (max-width: 991px) {
    & {
      margin-bottom: 10px;
    }
  }
  & .card-body {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
}
</style>
